// Skeleton — animated loading placeholder (PRD §9.4 +
// frontend_architecture.md §2 + UI brief §6.3, B1f PR2).
//
// UI brief §6.3: "skeletons, never spinners". A skeleton is a
// dimensionless rectangle the caller sizes via className — caller
// owns the layout, this owns the look (muted fill + pulse). Always
// aria-hidden; the parent container should carry `aria-busy` and
// announce loading state.
//
// Usage will land starting in B1f PR3 (project list while
// useProjects() is pending), PR4 (shot list), PR5 (generations grid).

interface SkeletonProps {
  className?: string;
}

export function Skeleton({ className }: SkeletonProps): React.JSX.Element {
  const cls = [
    'bg-bg-muted animate-pulse rounded-2',
    className ?? '',
  ]
    .filter(Boolean)
    .join(' ');
  return <div aria-hidden="true" data-testid="skeleton" className={cls} />;
}
